import axios from "axios";
import useAuthStore from "../store/authStore";

const BASE_URL = process.env.REACT_APP_AESWEBSERVICE_API_URL;
// const BASE_URL = process.env.REACT_APP_AESWEBSERVICE_DEV_API_URL;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const { token } = useAuthStore.getState();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

let handled401 = false;
let handled403 = false;

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response?.status === 401 && !handled401) {
      handled401 = true;

      const { showSessionExpired} = useAuthStore.getState();

      showSessionExpired();
      window.location.href = "/";
      return Promise.resolve();
    }

    if (error.response?.status === 403 && !handled403) {
      handled403 = true;

      const { showForbiddenAccess} = useAuthStore.getState();

      showForbiddenAccess();
      window.location.href = "/";
      return Promise.resolve();
    }

    return Promise.reject(error);
  }
);

export default apiClient;
